import BasicDateInput from "components/BasicInputs/BasicDateInput";
import BasicSelect from "components/BasicInputs/BasicSelect";
import PageHeader from "components/Shared/PageHeader";
import Icon from "components/Shared/atoms/Icon";
import Table from "components/Table";
import { useSelector } from "react-redux";
import userAvatar from "assets/images/userAvatar.png";
import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setQueryParam } from "helpers/queryParam";
import useDateState from "helpers/useDateState";
import { apiGetUsers } from "api/userApi";
import { Call, Phone } from "@mui/icons-material";
import PhoneIcon from "assets/icons/phoneIcon";
import KeyIcon from "assets/icons/KeyIcon";
import { formatPrice } from "helpers";
import PlusIcon from "assets/icons/PlusIcon";
import useCurrency from "helpers/useCurrency";
import { useAppDispatch, useAppSelector } from "store/store";
import { apiGetUserCard } from "api/reports/userCardApi";
import { DateToString } from "components/Reports/DateFilter";

const UserAccountCard = () => {
  return (
    <div className="px-8">
      <PageHeader heading="کارت فعالیت کاربران" />
      <UserCard />
    </div>
  );
};

function UserCard() {
  const [searchParams] = useSearchParams();
  const dispatch = useAppDispatch();
  const store = useAppSelector((state: any) => state);
  const token = store.businessReducer.business.token;
 // const pagination = store.paginationReducer.pagination;
  const paginationState = store.paginationReducer
  let pagination: any = {}
  const users = store.userReducer.users || [];

  const [userId, setUserId] = useState(searchParams.get("userId"));
  const [user, setUser] = useState<Partial<UserInfo>>();
  const [tab, setTab] = useState("factors");
  const { fromDate, toDate, setDates } = useDateState();
  const { defCur } = useCurrency();
  let options: any = {};
  let args: any = {}
  useEffect(() => {
    if (userId) getUserCard(+userId, "initial");
  }, [userId, fromDate, toDate, tab]);

  useEffect(() => {
    if (userId) getUserCard(+userId, "detail");
  }, [paginationState]);

  async function getUserCard(userId: number, type: string) {
    try {
      const { sort, search } = paginationState || {};
      if (fromDate && toDate) {
        options.subColumn = "date";
        options.searchText = fromDate;
        options.searchTextAlt = toDate;
      }
      let pagination = {page: paginationState.page, limit: paginationState.limit}
      args = { pagination, token, search, sort, options, userId, tab, dispatch };
      if(type === "initial"){
        const userCard: { user: Partial<UserInfo> } = await apiGetUserCard({ ...args, tab: "info" });
        const table = await apiGetUserCard(args);
        if (userCard?.user) setUser(userCard.user);
      }else if(type === "detail"){
        await apiGetUserCard(args);
      }
    } catch (error) {}
  }

  return (
    <div className="flex flex-col gap-4">
      <div className="flex gap-4">
        <div className="w-60">
          <BasicDateInput
            range
            placeholder="کل سال مالی"
            defaultValues={fromDate && toDate ? [fromDate, toDate] : undefined}
            onChange={(dates) => setDates(dates)}
          />
        </div>
        <div className="w-60">
          <BasicSelect
            options={users}
            placeholder="کاربر"
            onChange={(val) => {
              setUserId(val);
              setQueryParam("userId", val);
            }}
            defaultValue={userId}
            withRefresh
            refreshList={() => dispatch(apiGetUsers(token))}
          />
        </div>
      </div>
      <div className="flex flex-col bg-white p-7">
        <div className="flex flex-wrap justify-between gap-2">
          <div className="flex gap-4">
            <Icon url={user?.avatar || userAvatar} classes={{ l1: "w-24 h-24", l2: "w-auto" }} />
            <div className="flex flex-col justify-center gap-4">
              <span className="text-lg">
                {user?.firstName} {user?.lastName}
              </span>
              {user?.phone && (
                <div className="flex items-center gap-2">
                  <PhoneIcon scale={0.8} />
                  <span className="text-dark-2">{user?.phone}</span>
                </div>
              )}
            </div>
          </div>
          <div className="flex items-center gap-4 px-6 whitespace-nowrap">
            <div className="flex items-center gap-2">
              <KeyIcon scale={0.7} />
              <span>آخرین فعالیت:</span>
            </div>
            <span>{user?.lastActivity || DateToString(Date.now())}</span>
          </div>
        </div>
        <div className="flex flex-col gap-4 p-6 mt-2">
          <div className="flex flex-wrap items-center justify-between gap-3 md:flex-nowrap">
            <Info
              title="مجموع فروش"
              currency={defCur.en_title}
              price={user?.amountSaleFactor}
              factorCount={user?.countSaleFactors}
            />
            <Info
              title="مجموع خرید"
              currency={defCur.en_title}
              price={user?.amountBuyFactor}
              factorCount={user?.countBuyFactors}
            />
          </div>
          <div className="flex flex-wrap items-center justify-between gap-3 md:flex-nowrap">
            <Info
              title="مجموع دریافت"
              currency={defCur.en_title}
              price={user?.amountReceiveTransaction}
              transactionCount={user?.countReceiveTransactions}
            />
            <Info
              title="مجموع پرداخت"
              currency={defCur.en_title}
              price={user?.amountPaymentTransaction}
              transactionCount={user?.countPaymentTransactions}
            />
          </div>
        </div>
      </div>
      <Table
        type="userAccountCard"
        onTabChange={(options) => {
          setTab(options?.activeTab.apiKey);
        }
      }
        onSearch={(options) => {}}
      />
    </div>
  );
}

function Info(props: {
  title: string;
  currency: string;
  price?: number | string;
  factorCount?: number;
  transactionCount?: number;
  extraPrice?: number;
}) {
  return (
    <div className="flex items-center gap-x-3 whitespace-nowrap w-[500px] flex-wrap">
      <span className="pl-4 text-dark-3">{props.title}</span>
      <div className="flex items-center gap-1">
        <span className="text-dark-1">{props.price ? formatPrice(props.price) : 0}</span>
        <span className="text-dark-3">{props.currency}</span>
      </div>
      {props.factorCount && <span className="text-dark-3">{`(${props.factorCount} فاکتور)`}</span>}
      {props.transactionCount && <span className="text-dark-3">{`(${props.transactionCount} تراکنش)`}</span>}
      {props.extraPrice && (
        <div className="flex items-center">
          <span>{"("}</span>
          <div className="flex items-center gap-1">
            <PlusIcon scale={0.7} color="#1E8E1B" />
            <span className="text-[#1E8E1B]">{formatPrice(props.extraPrice)}</span>
            <span className="text-dark-3">{props.currency}</span>
          </div>
          <span>{")"}</span>
        </div>
      )}
    </div>
  );
}

export default UserAccountCard;
